module.exports = __webpack_public_path__ + "img/pic-paging-faq-4.c8134f88.jpg";